import {
  PERFORMANCEAPPRAISALDETAIL_LOADING,
  GET_PERFORMANCEAPPRAISALDETAIL,
  GET_PERFORMANCEAPPRAISALDETAIL_SUCCESS,
  GET_PERFORMANCEAPPRAISALDETAIL_FAIL,
  ADD_PERFORMANCEAPPRAISALDETAIL_SUCCESS,
  ADD_PERFORMANCEAPPRAISALDETAIL_FAIL,
  DELETE_PERFORMANCEAPPRAISALDETAIL_SUCCESS,
  DELETE_PERFORMANCEAPPRAISALDETAIL_FAIL,
  UPDATE_PERFORMANCEAPPRAISALDETAIL_SUCCESS,
  UPDATE_PERFORMANCEAPPRAISALDETAIL_FAIL,
  PERFORMANCEAPPRAISALDETAIL_RESET
} from "./actionType";

const INIT_STATE = {
  performanceAppraisalDetails: [],
  error: {},
};

const PerformanceAppraisalDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PERFORMANCEAPPRAISALDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PERFORMANCEAPPRAISALDETAIL:
          return {
            ...state,
            performanceAppraisalDetails: action.payload.data,
            isPerformanceAppraisalDetailCreated: false,
            isPerformanceAppraisalDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PERFORMANCEAPPRAISALDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_PERFORMANCEAPPRAISALDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPerformanceAppraisalDetailCreated: false,
            isPerformanceAppraisalDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PERFORMANCEAPPRAISALDETAIL: {
      return {
        ...state,
        isPerformanceAppraisalDetailCreated: false,
        loading: true,
      };
    }

    case PERFORMANCEAPPRAISALDETAIL_LOADING: {
      return {
        ...state,
        isPerformanceAppraisalDetailCreated: false,
        loading: true,
      };
    }

    case ADD_PERFORMANCEAPPRAISALDETAIL_SUCCESS:
      return {
        ...state,
        isPerformanceAppraisalDetailCreated: true,
        loading: false,
        performanceAppraisalDetails: [action.payload.data, ...state.performanceAppraisalDetails],
      };

    case ADD_PERFORMANCEAPPRAISALDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PERFORMANCEAPPRAISALDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isPerformanceAppraisalDetailCreated: true,
        performanceAppraisalDetails: state.performanceAppraisalDetails.filter(
          performanceAppraisalDetail => performanceAppraisalDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PERFORMANCEAPPRAISALDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PERFORMANCEAPPRAISALDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isPerformanceAppraisalDetailCreated: true,
        performanceAppraisalDetails: state.performanceAppraisalDetails.map(performanceAppraisalDetail =>
          performanceAppraisalDetail.id.toString() === action.payload.data.id.toString() ? { ...performanceAppraisalDetail, ...action.payload.data } : performanceAppraisalDetail
        ),
      };

    case UPDATE_PERFORMANCEAPPRAISALDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PERFORMANCEAPPRAISALDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default PerformanceAppraisalDetail;